module.exports = __webpack_public_path__ + "img/@logo_ibk.307d8eb0.svg";